import EmptyState from "ds/components/EmptyState";
import { EmptystateShareColored } from "components/icons/generated";
import Box from "ds/components/Box";

const UserIdpGroupsEmpty = () => {
  return (
    <Box align="center" justify="center" grow="1">
      <EmptyState title="User doesn’t have any IdP groups yet" icon={EmptystateShareColored} />
    </Box>
  );
};

export default UserIdpGroupsEmpty;
